var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9372_7624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9372_7624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 17.4166C5.10658 17.4166 4.73383 17.2615 4.42376 16.9515C4.11369 16.6414 3.95866 16.2687 3.95866 15.8333C3.95866 15.3978 4.11369 15.0251 4.42376 14.715C4.73383 14.405 5.10658 14.2499 5.54199 14.2499C5.97741 14.2499 6.35015 14.405 6.66022 14.715C6.97029 15.0251 7.12533 15.3978 7.12533 15.8333C7.12533 16.2687 6.97029 16.6414 6.66022 16.9515C6.35015 17.2615 5.97741 17.4166 5.54199 17.4166ZM13.4587 17.4166C13.0232 17.4166 12.6505 17.2615 12.3404 16.9515C12.0304 16.6414 11.8753 16.2687 11.8753 15.8333C11.8753 15.3978 12.0304 15.0251 12.3404 14.715C12.6505 14.405 13.0232 14.2499 13.4587 14.2499C13.8941 14.2499 14.2668 14.405 14.5769 14.715C14.887 15.0251 15.042 15.3978 15.042 15.8333C15.042 16.2687 14.887 16.6414 14.5769 16.9515C14.2668 17.2615 13.8941 17.4166 13.4587 17.4166ZM4.11699 3.16659H15.7941C16.0975 3.16659 16.3285 3.30183 16.4868 3.57231C16.6451 3.8428 16.6517 4.11659 16.5066 4.39367L13.6962 9.46033C13.551 9.72422 13.3564 9.92874 13.1123 10.0739C12.8682 10.219 12.601 10.2916 12.3107 10.2916H6.41283L5.54199 11.8749H15.042V13.4583H5.54199C4.94824 13.4583 4.49963 13.1977 4.19616 12.6765C3.89269 12.1553 3.87949 11.6374 4.15658 11.1228L5.22533 9.18325L2.37533 3.16659H0.791992V1.58325H3.36491L4.11699 3.16659Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.cb2b3b4766f2f914592c51418e22e98d.svg";
export { ForwardRef as ReactComponent };